// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__dSVV9","file":"styles_file__3mnIT"};